module.exports = __webpack_public_path__ + "img/Logo_iNoe_72px.e9e4c2a7.png";